module.exports = __webpack_public_path__ + "static/media/brain.233478e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/BodyView/brain.svg
// module id = 357
// module chunks = 0